import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ProjectCard from '../components/ProjectCard';
import { projects } from '../data/projects';
import './Projects.css';
import '../styles/common.css';

function Projects() {
  const { t } = useTranslation();
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('.project-card-wrap').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <main className="projects-page">
      <div className="projects-header">
        <span className="section-kicker">{t('projects.kicker')}</span>
        <h1 className="projects-title">{t('projects.title')}</h1>
        <p className="projects-desc">{t('projects.desc')}</p>
      </div>
      <div className="project-grid">
        {projects.map((project, index) => (
          <div
            key={index}
            className="project-card-wrap"
            style={{ transitionDelay: `${index * 0.07}s` }}
          >
            <ProjectCard {...project} />
          </div>
        ))}
      </div>
    </main>
  );
}

export default Projects;
